import {Vector3, AlwaysDepth} from 'three'

import { attrBelt, formatBelt } from '../configEntities/groupsAttr.js'

import { colorSizeAleat } from '../groupsEntities/galaxy.js'
import { Object } from '../groupsEntities/entitiesGroups.js'

import {sceneManager} from '../script.js'

import meteourTexture from '../../../assets/textures/asteroids/asteroid.png'

import { pushShift } from '../groupsEntities/entitiesGroups.js'
import { animateParts} from '../utils/many-bodies.js'

import { randomNormal } from '../helpers.js'

export class Belt {
  constructor(centerElement) {
    this.name = 'Asteroid Belt'
    this.distCam = 8000
    this.qtd = 2000
    this.meteourTexture = meteourTexture
    this.blending = AlwaysDepth

    this.maxSpeed = 5e-3
    this.minSpeed = 1e-3
    this.inclSpeed = 2e-7
    this.speeds = []
    this.parameters = this.generateAttr(this.qtd)
    this.centerElement = centerElement

    this.R = formatBelt.R

    this.element = new Object(
      this.name,
      this.distCam,
      this.labelPosition(),
      this.parameters,
      this.blending,
      this.meteourTexture,
    )
    sceneManager.commands.addParticlesHighlight(1e5, this.element)
    
  }

  generateAttr(numPoints) {
    let coord = [];
    let colors = [];
    let sizes = [];
    let shift = [];
    let randValue = []
  
    for (let i = 0; i < numPoints; i++) {
        const targetRMean = 0.5;
        const targetRStdDev = formatBelt.r /1.25;  
        const targetR = Math.abs(randomNormal(targetRMean, targetRStdDev));

        const targetC = Math.random() * formatBelt.r + formatBelt.R;

        const thetaMean = 0;
        const thetaStdDev = Math.PI * formatBelt.thetaSet;
        const theta = randomNormal(thetaMean, thetaStdDev) * formatBelt.circle;

        const phiMean = Math.PI;
        const phiStdDev = Math.PI * formatBelt.phiSet;
        const phi = randomNormal(phiMean, phiStdDev) * formatBelt.circle;

        const x = (targetC + targetR * Math.cos(theta)) * Math.cos(phi);
        const z = (targetC + targetR * Math.cos(theta)) * Math.sin(phi);
        const y = targetR * Math.sin(theta);

        let aleat = colorSizeAleat(attrBelt);
        colors.push(aleat.color);
        sizes.push(aleat.size);
        randValue.push(Math.random() * 10.0*i)

        const randomSpeed = Math.random() * (this.maxSpeed - this.minSpeed) + this.minSpeed
        this.speeds.push(randomSpeed)

        pushShift(shift, 2.5);

        coord.push(new Vector3(x, y, z));
    }

    return { coord, colors, sizes,shift, randValue}
  }
  labelPosition() {
    const position = new Vector3(formatBelt.R, formatBelt.r, 0)

    return position
  }

  centerOrbit() {
    this.element.objects.position.copy(this.centerElement.mesh.position)
  }
    animate(speed) {
      if (!this.element.objects) return;
      let distSun = sceneManager.camera.position.distanceTo(this.centerElement.mesh.position);
      this.centerOrbit()
      animateParts(
        this.element.objects,
        speed,
        this.speeds,
      );
     
     this.element.setLabelVisible(this.centerElement.mesh.position, sceneManager.camera, sceneManager.commands.controls.labels)
      this.element.pointMaterial.uniforms.time.value += speed*this.inclSpeed

      this.element.pointMaterial.uniforms.opacity.value = Math.max(0.1, Math.min(1, distSun / this.R));
    }
}


